import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { SOLUTIONS } from '../solutions/data';

function Footer({ navigateToAnchor }) {
    const goAnchor = (e, anchor) => {
        e.preventDefault();
        if (navigateToAnchor) navigateToAnchor(anchor);
    };
    return (
        <footer className="site-footer mt-auto">
            <Container>
                <Row className="gy-4">
                    <Col lg={2} md={12} className="mb-3 mb-lg-0">
                        <div className="d-flex align-items-center gap-2 mb-2">
                            <img src="qcoda_icon_white.png" alt="Qcoda — Governed AI Orchestration" height="30" className="rounded" />
                            <span className="fw-bold fs-5">Qcoda</span>
                        </div>
                        <p className="text-dim mb-3" style={{ fontSize: '0.875rem' }}>
                            Governed AI orchestration. The control plane for AI at work.
                        </p>
                        <div className="d-flex gap-3 mb-2" style={{ fontSize: '0.875rem' }}>
                            <a href="https://x.com/qcoda_ai" target="_blank" rel="noopener noreferrer">X</a>
                            <a href="https://www.linkedin.com/company/qcoda" target="_blank" rel="noopener noreferrer">LinkedIn</a>
                        </div>
                        <div style={{ fontSize: '0.875rem' }}>
                            <a href="mailto:hello@qcoda.com">hello@qcoda.com</a>
                        </div>
                    </Col>
                    <Col lg={2} md={3} sm={6}>
                        <p className="footer-heading">Platform</p>
                        <ul className="list-unstyled" style={{ fontSize: '0.875rem' }}>
                            <li className="mb-2">
                                <a href="/#why" onClick={(e) => goAnchor(e, 'why')} className="footer-link">Why Qcoda</a>
                            </li>
                            <li className="mb-2">
                                <a href="/#pillars" onClick={(e) => goAnchor(e, 'pillars')} className="footer-link">Pillars</a>
                            </li>
                            <li className="mb-2">
                                <a href="/#alignment" onClick={(e) => goAnchor(e, 'alignment')} className="footer-link">Alignment thread</a>
                            </li>
                            <li className="mb-2">
                                <a href="/#enterprise" onClick={(e) => goAnchor(e, 'enterprise')} className="footer-link">Enterprise</a>
                            </li>
                            <li className="mb-2">
                                <a href="/#faq" onClick={(e) => goAnchor(e, 'faq')} className="footer-link">FAQ</a>
                            </li>
                        </ul>
                    </Col>
                    <Col lg={3} md={6} sm={6}>
                        <p className="footer-heading">Solutions</p>
                        <ul className="list-unstyled" style={{ fontSize: '0.875rem' }}>
                            <li className="mb-2">
                                <Link to="/solutions" className="footer-link">All solutions</Link>
                            </li>
                            {SOLUTIONS.map((s) => (
                                <li className="mb-2" key={s.slug}>
                                    <Link to={`/solutions/${s.slug}`} className="footer-link">{s.title}</Link>
                                </li>
                            ))}
                        </ul>
                    </Col>
                    <Col lg={2} md={6} sm={6}>
                        <p className="footer-heading">Resources</p>
                        <ul className="list-unstyled" style={{ fontSize: '0.875rem' }}>
                            <li className="mb-2">
                                <Link to="/blog" className="footer-link">Blog</Link>
                            </li>
                            <li className="mb-2">
                                <Link to="/llmesh" className="footer-link">LLMesh</Link>
                            </li>
                            <li className="mb-2">
                                <a href="/llms.txt" className="footer-link">LLMs.txt (AI index)</a>
                            </li>
                        </ul>
                    </Col>
                    <Col lg={3} md={6} sm={6}>
                        <p className="footer-heading">Company</p>
                        <ul className="list-unstyled" style={{ fontSize: '0.875rem' }}>
                            <li className="mb-2">
                                <Link to="/company" className="footer-link">About</Link>
                            </li>
                            <li className="mb-2">
                                <Link to="/company/press" className="footer-link">Press</Link>
                            </li>
                            <li className="mb-2">
                                <Link to="/contact" className="footer-link">Contact</Link>
                            </li>
                            <li className="mb-2">
                                <Link to="/privacy" className="footer-link">Privacy Policy</Link>
                            </li>
                            <li className="mb-2">
                                <Link to="/terms" className="footer-link">Terms of Service</Link>
                            </li>
                        </ul>
                    </Col>
                </Row>
                <Row className="mt-4 pt-3" style={{ borderTop: '1px solid rgba(255,255,255,0.06)' }}>
                    <Col className="text-center text-dim" style={{ fontSize: '0.8rem' }}>
                        &copy; {new Date().getFullYear()} Qcoda LLC. All rights reserved.
                    </Col>
                </Row>
            </Container>
        </footer>
    );
}

export default Footer;
